import script from "./icon-arrow-right.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-arrow-right.vue?vue&type=script&lang=ts&setup=true"

import "./icon-arrow-right.vue?vue&type=style&index=0&id=7891d288&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7891d288"]])

export default __exports__